<template>
  <v-breadcrumbs :items="routes" />
</template>

<script>
export default {
  computed: {
    routes () {
      const data = [
        {
          text: 'dashboard',
          append: true,
          exact: true,
          to: '/'
        }
      ]
      const route = this.$route
      return route.name === 'dashboard' ? data : [
        ...data,
        {
          text: route.name.replace(/[.]/g , ' '),
          append: true,
          exact: true,
          to: route.path
        }
      ]
    }
  }
}
</script>
